/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { Gender } from '../types/utils';
import { UserID } from './user-model';

export class ApproveUserInput {
	id: UserID = ''

	address?: string

	addressZipcode?: string

	addressCity?: string

	addressCountry?: string

	birthCity?: string

	birthDate?: Date

	citizenship?: string

	firstName?: string

	gender?: Gender

	lastName?: string
}